<template>
  <section class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <!-- <el-form-item>
          <el-input v-model="filters.name" placeholder="名称"></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="list">刷新</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleEdit($event)">新增</el-button>
        </el-form-item> -->
      </el-form>
    </div>

    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        v-loading="loading"
        height="100%"
        :data="results"
        highlight-current-row
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column prop="id" label="编号"></el-table-column>

        <el-table-column prop="type" label="类型"></el-table-column>

        <el-table-column prop="fileKey" label="FileKey"></el-table-column>

        <el-table-column prop="status" label="状态">
          <template #default="{ row }">
            {{
              row.status === 0
                ? "未开始"
                : row.status === 1
                ? "进行中"
                : row.status === 2
                ? "完成"
                : row.status === 3
                ? "失败"
                : row.status
            }}
          </template>
        </el-table-column>

        <el-table-column prop="totalCount" label="总数"></el-table-column>

        <el-table-column prop="successCount" label="成功数量"></el-table-column>

        <el-table-column prop="processedCount" label="已处理数量"></el-table-column>

        <el-table-column prop="elapsed" label="耗时">
          <template #default="{ row }">{{ parseInt(row.elapsed / 1000) }} s</template>
        </el-table-column>

        <!-- <el-table-column prop="createUserId" label="createUserId"></el-table-column> -->

        <el-table-column prop="createUserName" label="创建人"></el-table-column>

        <el-table-column prop="createTime" label="创建时间"></el-table-column>

        <el-table-column label="操作" width="105">
          <template #default="{ row }">
            <!-- <el-button size="mini" type="primary" @click="handleEdit(row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(row)">删除</el-button> -->
            <el-button size="mini" type="primary" @click="showTaskLog(row)">导入记录</el-button>
          </template>
        </el-table-column>
        <template #empty>
          <el-empty />
        </template>
      </el-table>
    </div>

    <div ref="pagebar" class="pagebar">
      <el-pagination
        :page-sizes="[20, 50, 100, 300]"
        :current-page="page.page"
        :page-size="page.limit"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      >
      </el-pagination>
    </div>

    <edit ref="editRef" @success="list" />
    <task-log ref="taskLogRef" />
  </section>
</template>

<script>
import mainHeight from "@/utils/mainHeight";
import TaskLog from "..//import-task-log/index";
import Edit from "./components/Edit";
export default {
  name: "ImportTask",
  components: { Edit, TaskLog },
  data() {
    return {
      mainHeight: "300px",
      results: [],
      loading: true,
      page: {},
      filters: {},
      selectedRows: [],
    };
  },
  mounted() {
    mainHeight(this);
    this.list();
  },
  methods: {
    async list() {
      this.loading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("mall:/api/admin/import-task/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.loading = false;
      }
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    handleEdit(row) {
      if (row.id) {
        this.$refs.editRef.showEdit(row);
      } else {
        this.$refs.editRef.showEdit();
      }
    },
    handleDelete(row) {
      const me = this;
      me.$confirm("是否确认删除?")
        .then(() => {
          me.axios
            .form("mall:/api/admin/import-task/delete", {
              ids: row.id,
            })
            .then(() => {
              this.$notify.success("删除成功");
              me.list();
            })
            .catch((e) => {
              this.$notify.error(e.message || e);
            });
        })
        .catch((e) => {});
    },
    showTaskLog(task) {
      this.$refs.taskLogRef.show(task.id);
    },
  },
};
</script>

<style lang="scss" scoped></style>
